import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const getUserSettings = () => {
  return Helpers.get(Constants.USERSETTINGS_URL);
};

export const modifyUserSettings = userSettings => {
  return Helpers.put(Constants.USERSETTINGS_URL, {}, userSettings);
};

export const resetUserSettings = id => {
  return Helpers.get(`${Constants.USERSETTINGS_URL}/reset/${id}`);
};

export const getUserSettingsConfig = () => {
  return Helpers.get(`${Constants.USERSETTINGS_URL}/config`);
};
